var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransparency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2002 6H15.8002C12.4399 6 10.7597 6 9.47625 6.65396C8.34728 7.2292 7.4294 8.14708 6.85416 9.27606C6.2002 10.5595 6.2002 12.2397 6.2002 15.6V32.4C6.2002 35.7603 6.2002 37.4405 6.85416 38.7239C7.4294 39.8529 8.34728 40.7708 9.47625 41.346C10.7597 42 12.4399 42 15.8002 42H32.6002C35.9605 42 37.6407 42 38.9241 41.346C40.0531 40.7708 40.971 39.8529 41.5462 38.7239C42.2002 37.4405 42.2002 35.7603 42.2002 32.4V26M24.2002 16H32.2002V24M31.2002 7V4M39.0789 9.12132L41.2002 7M41.2207 17H44.2207M6.2002 26.6942C7.50407 26.8955 8.83994 27 10.2002 27C18.9729 27 26.7309 22.6552 31.4396 16",
    stroke: "#83F279",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransparency);
export default __webpack_public_path__ + "static/media/transparency.1e23d319687a1b7e30c285590b4057ea.svg";
export { ForwardRef as ReactComponent };